import { render, staticRenderFns } from "./UserFormModal.vue?vue&type=template&id=18f5458f&"
import script from "./UserFormModal.vue?vue&type=script&lang=js&"
export * from "./UserFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports